/**
 * HM-510 cluster 24 Room Service admin — client API.
 *
 * Riusa endpoint cluster 9 esistenti:
 *  - GET   /room-service/orders?status=  — lista ordini
 *  - PATCH /room-service/orders/:id      — cambio stato (FSM)
 */
import { api } from './client.js';

export type RsOrder = {
  id: string;
  status: 'pending' | 'preparing' | 'delivered' | 'cancelled';
  roomId: string;
  bookingId: string;
  total: string;
  note: string | null;
  placedAt: string;
};

export type RsOrderStatus = RsOrder['status'];

export async function listRsOrders(status?: RsOrderStatus): Promise<{ orders: RsOrder[] }> {
  const qs = status ? `?status=${status}` : '';
  return api(`/room-service/orders${qs}`);
}

export async function patchRsOrderStatus(
  id: string,
  next: RsOrderStatus,
): Promise<{ ok: boolean }> {
  return api(`/room-service/orders/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ status: next }),
  });
}
